jQuery(document).ready(function () {
    $(document).on('click', '.main-product #addToCart', function(){
        setTimeout(function(){
            if (jQuery('.main-sidebar .cart__details .flex-buttons button#CheckOut').is(':disabled')) {
                var total_items_cart = $('#site-cart-sidebar .cart__items .cart-item').length;
                console.log(total_items_cart);
                if(total_items_cart > 0){
                    jQuery('.main-sidebar .cart__details .flex-buttons button#CheckOut').removeAttr('disabled');
                }
            }
        }, 4000);
    })
});
// jQuery(document).ready(function (){
//     if($('.buyBox-sticky-atc-wrapper').length > 0){
//       if($('.zubehoer-11-12-25').length > 0){
//         setTimeout(function(){
//           var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
//           $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
//           $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
//         },500);
//         $(document).on('change', '.product-variant__item input[type=radio]', function(){
//             setTimeout(function(){
//                 var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
//                 $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
//                 $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail .sticky-atc-bottle-icon img').attr('src',prd_img);
                
//             },500);
//         });
//         $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
//       /* desktop  */
//        var Div_html = $('.simple-product-sticky-atc-inner-mobile .sticky-fcol .sticky-atc-bottle-icon').html();
     
//        $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail').prepend('<div class="sticky-atc-bottle-icon">' + Div_html + '</div>');
//      }else if ($('.sl-12EA7881').length > 0) {   // <-- fixed length
//         $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
//       }else if ($('.zubehoer-gerfierer-richtig').length > 0) {   // <-- fixed length
//         $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
//         var img_pr = $('.simple-product-sticky-atc-inner-desktop .sticky-fcol-product-detail img').attr('src');
//         $('.simple-product-sticky-atc-inner-mobile .sticky-atc-bottle-icon img').attr('src',img_pr);
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
//         $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
//       }
//     }
// });

jQuery(document).ready(function (){
    if($('.buyBox-sticky-atc-wrapper').length > 0){
      /* if($('.zubehoer-11-12-25').length > 0){
        if($('.rab-sticky-fcol').length && $('.rab-sticky-fcol').attr('data-variants') > 1){
          setTimeout(function(){
            var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          },500);
          $(document).on('change', '.product-variant__item input[type=radio]', function(){
              setTimeout(function(){
                  var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
                  $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
                  $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail .sticky-atc-bottle-icon img').attr('src',prd_img);
                  
              },500);
          });
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');

          var Div_html = $('.simple-product-sticky-atc-inner-mobile .sticky-fcol .sticky-atc-bottle-icon').html();
      
          $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail').prepend('<div class="sticky-atc-bottle-icon">' + Div_html + '</div>');
      
        }else{
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          var img_pr = $('.simple-product-sticky-atc-inner-desktop .sticky-fcol-product-detail img').attr('src');
          $('.simple-product-sticky-atc-inner-mobile .sticky-atc-bottle-icon img').attr('src',img_pr);
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
        }

      }else if($('.zubehoer-standrat-ohne-zus').length > 0){
        if($('.rab-sticky-fcol').length && $('.rab-sticky-fcol').attr('data-variants') > 1){
          setTimeout(function(){
            var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          },500);
          $(document).on('change', '.product-variant__item input[type=radio]', function(){
              setTimeout(function(){
                  var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
                  $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
                  $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail .sticky-atc-bottle-icon img').attr('src',prd_img);
                  
              },500);
          });
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');

        var Div_html = $('.simple-product-sticky-atc-inner-mobile .sticky-fcol .sticky-atc-bottle-icon').html();
      
        $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail').prepend('<div class="sticky-atc-bottle-icon">' + Div_html + '</div>');
        
      }else{
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          var img_pr = $('.simple-product-sticky-atc-inner-desktop .sticky-fcol-product-detail img').attr('src');
          $('.simple-product-sticky-atc-inner-mobile .sticky-atc-bottle-icon img').attr('src',img_pr);
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
        }
        
     }else if ($('.sl-12EA7881').length > 0) {   // <-- fixed length
        $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
        $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
      
      }else if ($('.zubehoer-gerfierer-richtig').length > 0) {   // <-- fixed length
        if($('.rab-sticky-fcol').length && $('.rab-sticky-fcol').attr('data-variants') > 1){
          setTimeout(function(){
            var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          },500);
          $(document).on('change', '.product-variant__item input[type=radio]', function(){
              setTimeout(function(){
                  var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
                  $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
                  $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail .sticky-atc-bottle-icon img').attr('src',prd_img);
                  
              },500);
          });
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');

        var Div_html = $('.simple-product-sticky-atc-inner-mobile .sticky-fcol .sticky-atc-bottle-icon').html();
      
        $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail').prepend('<div class="sticky-atc-bottle-icon">' + Div_html + '</div>');
        
      }else{
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          var img_pr = $('.simple-product-sticky-atc-inner-desktop .sticky-fcol-product-detail img').attr('src');
          $('.simple-product-sticky-atc-inner-mobile .sticky-atc-bottle-icon img').attr('src',img_pr);
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
        }
      } */
     
      let template = $('.buyBox-sticky-atc-wrapper').attr('data-template');
      let total_variants = $('.buyBox-sticky-atc-wrapper').attr('data-variants');

      if(template == 'product.multistep-bundle' && template == 'product.subscription-bundle'){

      }else{
        if(total_variants > 1){
          setTimeout(function(){
            var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
            console.log(prd_img);
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
            $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          },500);

          $(document).on('change', '.product-variant__item input[type=radio]', function(){
              setTimeout(function(){
                  var prd_img = $('.main-product .product-gallery-slider-wrapper .slick-current img').attr('src');
                  $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon img').attr('src',prd_img);
                  $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail .sticky-atc-bottle-icon img').attr('src',prd_img);
                  
              },500);
          });

          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');

          var Div_html = $('.simple-product-sticky-atc-inner-mobile .sticky-fcol .sticky-atc-bottle-icon').html();
      
          $('.simple-product-sticky-atc-inner-desktop .sticky-fcol.sticky-fcol-product-detail').prepend('<div class="sticky-atc-bottle-icon">' + Div_html + '</div>');
      
        }else{
          $('.buyBox-sticky-atc-wrapper .sticky-fbox .sticky-atc-bottle-icon').parent().addClass('hide');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol').removeClass('hide');
          var img_pr = $('.simple-product-sticky-atc-inner-desktop .sticky-fcol-product-detail img').attr('src');
          $('.simple-product-sticky-atc-inner-mobile .sticky-atc-bottle-icon img').attr('src',img_pr);
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol .sticky-atc-bottle-icon .sticky-cart-items').css('display','none');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:nth-child(1)').css('flex', '0 0 10%');
          $('.buyBox-sticky-atc-wrapper .buyBox-sticky-inner .buyBox-sticky-atc-grid .sticky-fbox .sticky-fcol:last-child').css('flex','0 0 85%');
        }
      }

    }
});
